import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { logoutWithRedirect } from '../services/stores/auth/slice';

/**
 * Custom hook to handle logout with automatic navigation and cache cleanup
 * Use this instead of dispatching logout directly when you want to navigate
 */
export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = async () => {
    try {
      // Clear all React Query cache to prevent data leakage between users
      queryClient.clear();
      
      // Alternatively, you can use queryClient.removeQueries() to remove all queries
      // or queryClient.invalidateQueries() to invalidate them
      
      // Dispatch the logout thunk
      await dispatch(logoutWithRedirect() as any);
      
      // Navigate to login page
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
      // Fallback - still clear cache and navigate even if logout fails
      queryClient.clear();
      navigate('/login', { replace: true });
    }
  };

  return logout;
};
